import { render, staticRenderFns } from "./ContactsBlock.vue?vue&type=template&id=9dcef538&"
import script from "./ContactsBlock.vue?vue&type=script&lang=js&"
export * from "./ContactsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports